export default __webpack_public_path__ + "media/images/brands/robert-welch-59392d19cb85fcbd44e905c723719e58.png";